// WinnerModal.js

import React from 'react';
import { OptimizedModal } from './OptimizedModal'; // Yeni temel bileşen

// ✅ React.memo ile sarmalandı
export const WinnerModal = React.memo(({ winnerName, onClose, isOpen }) => {
    return (
        // ✅ OptimizedModal kullanıldı
        <OptimizedModal isOpen={isOpen} onClose={onClose}>
            {/* İçerik, kullanıcının optimize edilmiş örneğinden alınmıştır (daha basit ve temiz). */}
            <div className="bg-gradient-to-br from-yellow-900 to-gray-900 rounded-2xl p-8 max-w-lg w-full border-4 border-yellow-400 shadow-2xl">
                <div className="text-center">
                    <div className="text-6xl mb-4 animate-bounce">🏆</div>
                    <h2 className="text-4xl font-bold text-yellow-400 mb-4">
                        ZAFER!
                    </h2>
                    <p className="text-2xl text-white mb-6">
                        {winnerName} kazandı!
                    </p>
                    <button
                        onClick={onClose}
                        className="px-8 py-3 bg-yellow-500 hover:bg-yellow-600 rounded-lg font-bold text-black text-lg transition-colors"
                    >
                        Ana Menüye Dön
                    </button>
                </div>
            </div>
        </OptimizedModal>
    );
});